module.exports = __webpack_public_path__ + "./images/3e04eeeeda603abe9d1e33c212b6cd04.webp";